import { RoleResources } from '..'

import financialSupervisor from './finalcialSupervisor'
import financialEvaluation from './financerEvaluation'

export const external: RoleResources = {
  financer_supervisor: financialSupervisor,
  financer_evaluations: financialEvaluation,
}
